<template>
    <div>

        <vue-headful title="OSHA :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-folder-open"></i> OSHA</li>&nbsp;
                <router-link :to="`/osha/submit`" class="btn btn-sm btn-success">
                    OSHA E-File
                </router-link>
            </ol>
        </h4>

        <div class="card">
            <div v-if="error" class="card-body">
                <div v-if="loading" class="text-center">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                </div>
                You do not have an OSHA Api Key set, go to <router-link to="/admin/settings">Account Settings</router-link> to add your key.
            </div>
            <div v-else class="card-body">
                <div v-if="loading" class="text-center">
                    <i class="fa fa-circle-o-notch fa-spin"></i>  Pulling Your OSHA Data...
                </div>
                <v-client-table v-else ref="RolesTable" :data="data" :columns="columns" :options="options">

                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['establishment_name', 'year_filing_for', 'annual_average_employees','total_hours_worked','total_deaths','total_dafw_cases','total_djtr_cases','total_other_cases','total_dafw_days','total_djtr_days','total_injuries','total_skin_disorders','total_respiratory_conditions','total_poisonings','total_hearing_loss','total_other_illnesses','tcr','dart'],
                options: {
                    headings: {
                        establishment_name: 'Establishment Name',
                        year_filing_for: 'Year Filing For',
                        annual_average_employees: 'Annual Average Employees',
                        total_hours_worked: 'Total Hours Worked',
                        total_deaths: 'Total Deaths',
                        total_dafw_cases: 'Total DAFW Cases',
                        total_djtr_cases: 'Total DJTR Cases',
                        total_other_cases: 'Total Other Cases',
                        total_dafw_days: 'Total DAFW Days',
                        total_djtr_days: 'Total DJTR Days',
                        total_injuries: 'Total Injuries',
                        total_skin_disorders: 'Total Skin Disorders',
                        total_respiratory_conditions: 'Total Respiratory Conditions',
                        total_poisonings: 'Total Poisonings',
                        total_hearing_loss: 'Total Hearing Loss',
                        total_other_illnesses: 'Total Other Illnesses',
                        tcr: 'TCR',
                        dart: 'DART',
                    }
                },
                data: [],
                loading: true,
            }
        },

        methods: {

        },

        mounted() {
            this.$http
                .get('osha')
                .then(response => {
                    if (response.data.error)
                    {
                        this.error = true;
                    }
                    else
                    {
                        this.data = response.data.data;
                    }

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        }
    }
</script>
